import { render, staticRenderFns } from "./LightLinearViz.vue?vue&type=template&id=06fead72&scoped=true"
import script from "./LightLinearViz.vue?vue&type=script&lang=js"
export * from "./LightLinearViz.vue?vue&type=script&lang=js"
import style0 from "./LightLinearViz.vue?vue&type=style&index=0&id=06fead72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fead72",
  null
  
)

export default component.exports